module.exports = "<p>view-schedule-task-dialog works!</p>\n"